import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserFormNewQueryVariables = Types.Exact<{
  specialistId: Types.Scalars['ID']['input'];
  notificationId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetCurrentUserFormNewQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly roles: ReadonlyArray<Types.AccountsUserRole>, readonly specialist?: { readonly __typename?: 'AccountsSpecialist', readonly email?: string | null, readonly uuid: string } | null, readonly notification?: { readonly __typename?: 'AccountsNotification', readonly id: string, readonly channelType: Types.AccountsNotificationChannelType, readonly adTypes: ReadonlyArray<Types.YalperAdType>, readonly monitorAdTypes: ReadonlyArray<Types.YalperAdType>, readonly selectedSensorGroups: ReadonlyArray<Types.YalperChecksSensorGroup>, readonly emailChannel: { readonly __typename?: 'AccountsEmailChannel', readonly email?: string | null }, readonly telegramChannel: { readonly __typename?: 'AccountsTelegramChannel', readonly xeniooUserUuid?: string | null }, readonly adTypeSensors: { readonly __typename?: 'AdTypeSensors', readonly context: ReadonlyArray<string>, readonly target: ReadonlyArray<string> }, readonly company: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly sensorGroups: { readonly __typename?: 'AccountsCompanySensorGroups', readonly red: ReadonlyArray<string>, readonly yellow: ReadonlyArray<string>, readonly gray: ReadonlyArray<string> } } } | null, readonly companies: ReadonlyArray<{ readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string, readonly sensorGroups: { readonly __typename?: 'AccountsCompanySensorGroups', readonly red: ReadonlyArray<string>, readonly yellow: ReadonlyArray<string>, readonly gray: ReadonlyArray<string> } }>, readonly sensors: ReadonlyArray<{ readonly __typename?: 'YalperSensor', readonly id: string, readonly name: string, readonly platform: Types.YalperPlatform, readonly isError: boolean }> } | null };

export type GetCurrentUserListQueryVariables = Types.Exact<{
  specialistId: Types.Scalars['ID']['input'];
}>;


export type GetCurrentUserListQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly specialist?: { readonly __typename?: 'AccountsSpecialist', readonly id: string, readonly name: string, readonly email?: string | null, readonly uuid: string, readonly notifications: ReadonlyArray<{ readonly __typename?: 'AccountsNotification', readonly id: string, readonly channelType: Types.AccountsNotificationChannelType, readonly adTypes: ReadonlyArray<Types.YalperAdType>, readonly emailChannel: { readonly __typename?: 'AccountsEmailChannel', readonly email?: string | null }, readonly telegramChannel: { readonly __typename?: 'AccountsTelegramChannel', readonly xeniooUserUuid?: string | null }, readonly company: { readonly __typename?: 'AccountsCompany', readonly name: string } }> } | null } | null };


export const GetCurrentUserFormNewDocument = gql`
    query GetCurrentUserFormNew($specialistId: ID!, $notificationId: ID) {
  currentUser {
    roles
    specialist(id: $specialistId) {
      email
      uuid
    }
    notification(id: $notificationId) {
      id
      channelType
      adTypes
      monitorAdTypes
      emailChannel {
        email
      }
      telegramChannel {
        xeniooUserUuid
      }
      adTypeSensors {
        context
        target
      }
      selectedSensorGroups
      company {
        id
        sensorGroups {
          red
          yellow
          gray
        }
      }
    }
    companies {
      id
      name
      sensorGroups {
        red
        yellow
        gray
      }
    }
    sensors {
      id
      name
      platform
      isError
    }
  }
}
    `;

/**
 * __useGetCurrentUserFormNewQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserFormNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserFormNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserFormNewQuery({
 *   variables: {
 *      specialistId: // value for 'specialistId'
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useGetCurrentUserFormNewQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserFormNewQueryPage, GetCurrentUserFormNewQueryVariables> & ({ variables: GetCurrentUserFormNewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserFormNewQueryPage, GetCurrentUserFormNewQueryVariables>(GetCurrentUserFormNewDocument, options);
      }
export function useGetCurrentUserFormNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserFormNewQueryPage, GetCurrentUserFormNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserFormNewQueryPage, GetCurrentUserFormNewQueryVariables>(GetCurrentUserFormNewDocument, options);
        }
export function useGetCurrentUserFormNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserFormNewQueryPage, GetCurrentUserFormNewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserFormNewQueryPage, GetCurrentUserFormNewQueryVariables>(GetCurrentUserFormNewDocument, options);
        }
export type GetCurrentUserFormNewQueryHookResult = ReturnType<typeof useGetCurrentUserFormNewQuery>;
export type GetCurrentUserFormNewLazyQueryHookResult = ReturnType<typeof useGetCurrentUserFormNewLazyQuery>;
export type GetCurrentUserFormNewSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserFormNewSuspenseQuery>;
export type GetCurrentUserFormNewQueryResult = Apollo.QueryResult<GetCurrentUserFormNewQueryPage, GetCurrentUserFormNewQueryVariables>;
export const GetCurrentUserListDocument = gql`
    query GetCurrentUserList($specialistId: ID!) {
  currentUser {
    specialist(id: $specialistId) {
      id
      name
      email
      uuid
      notifications {
        id
        channelType
        adTypes
        emailChannel {
          email
        }
        telegramChannel {
          xeniooUserUuid
        }
        company {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserListQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserListQuery({
 *   variables: {
 *      specialistId: // value for 'specialistId'
 *   },
 * });
 */
export function useGetCurrentUserListQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables> & ({ variables: GetCurrentUserListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>(GetCurrentUserListDocument, options);
      }
export function useGetCurrentUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>(GetCurrentUserListDocument, options);
        }
export function useGetCurrentUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>(GetCurrentUserListDocument, options);
        }
export type GetCurrentUserListQueryHookResult = ReturnType<typeof useGetCurrentUserListQuery>;
export type GetCurrentUserListLazyQueryHookResult = ReturnType<typeof useGetCurrentUserListLazyQuery>;
export type GetCurrentUserListSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserListSuspenseQuery>;
export type GetCurrentUserListQueryResult = Apollo.QueryResult<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>;